enum Role {
  SuperAdmin = 'SuperAdmin',
  ClientServices = 'ClientServices',
  OrganisationAdmin = 'OrganisationAdmin',
  WardAdmin = 'WardAdmin',
  HouseholdViewer = 'HouseholdViewer',
  WardViewer = 'WardViewer',
  Viewer = 'Viewer', // to be removed and replaced by ward viewer
}

export const householdAdminRoles = [Role.SuperAdmin, Role.ClientServices, Role.OrganisationAdmin];

export const internalAdminRoles = [Role.SuperAdmin, Role.ClientServices];

export const householdDataViewerRoles = [...householdAdminRoles, Role.HouseholdViewer, Role.Viewer];

export const wardDataAdminRoles = [...householdAdminRoles, Role.WardAdmin];

export enum Channel {
  BackendLetter = 'print_and_post',
  Letter = 'Letter',
  BackendSMS = 'sms',
  SMS = 'SMS',
}

export enum HTTPMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Delete = 'DELETE',
  Patch = 'PATCH',
}

export enum Benefit {
  PensionCredit = 'pension credit',
  AttendanceAllowance = 'attendance allowance',
  HealthyStart = 'healthy start',
  FreeSchoolMeals = 'free school meals',
}

export enum MapType {
  HouseholdMap = 'Household map',
  WardMap = 'Ward map',
  LocalAuthorityMap = 'Local Authority map',
}

export enum OutcomeTrackerType {
  Standard = 'Standard Outcome Tracking',
  ControlGroupAnalysis = 'Control Group Analysis',
}

export enum ReactSelectAction {
  InputChange = 'input-change',
  SelectOption = 'select-option',
  Clear = 'clear',
}

export enum DynamicFilters {
  HouseholdReferences = 'household_references',
  Postcodes = 'postcodes',
  LocalAuthorityAdministrative = 'local_authority_administrative',
  LocalAuthorityGeographic = 'local_authority',
  Ward = 'ward',
}

export enum SortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export enum CampaignStatus {
  Archived = 'Archived',
  SentToApi = 'sent to api',
  ReadyForReview = 'ready for review',
  Draft = 'draft',
  Complete = 'Complete',
  AwaitingApproval = 'Awaiting approval',
}

export enum CampaignType {
  Custom = 'Custom',
}

export enum TemplateOption {
  UPLOAD = 'upload',
  EXISTING = 'existing',
}
export enum All {
  label = 'All',
  value = 'ALL',
}

export enum CohortType {
  RadioName = 'cohort-by',
  Campaign = 'campaign',
  HouseholdReferences = 'pasted_household_references',
  Cohort = 'saved_cohort',
}

export enum FilterModalType {
  Edit = 'edit',
  Advanced = 'advanced',
  Summary = 'summary',
}
export default Role;
